/**
 * Quebra um texto com a marcação do WhatsApp (*negrito*, _itálico_, ~riscado~)
 * em trechos. Como no app, o marcador só vale fora de palavras: em
 * "actions_overdue" o sublinhado é texto, não itálico.
 */
export type WaSegment = { kind: "text" | "bold" | "italic" | "strike"; text: string };

const RE = /(?<![\p{L}\p{N}])(\*[^*\n]+\*|_[^_\n]+_|~[^~\n]+~)(?![\p{L}\p{N}])/gu;
const KIND: Record<string, WaSegment["kind"]> = { "*": "bold", _: "italic", "~": "strike" };

export function parseWhatsAppText(text: string): WaSegment[] {
  const out: WaSegment[] = [];
  let last = 0;
  for (const m of text.matchAll(RE)) {
    const tok = m[1]!;
    const at = m.index!;
    if (at > last) out.push({ kind: "text", text: text.slice(last, at) });
    out.push({ kind: KIND[tok[0]!]!, text: tok.slice(1, -1) });
    last = at + tok.length;
  }
  if (last < text.length) out.push({ kind: "text", text: text.slice(last) });
  return out;
}
